/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Status_ChangedInputs */

const vi_einvoice_err_status_changed = /** @type {(inputs: Einvoice_Err_Status_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có người vừa xử lý đơn này. Tải lại trang để xem tình trạng mới.`)
};

/**

* @param {Einvoice_Err_Status_ChangedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_status_changed = /** @type {((inputs?: Einvoice_Err_Status_ChangedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Status_ChangedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_status_changed(inputs)
});